import React from "react";
import { Link } from "react-router-dom";
import { AirplaneTilt } from "@phosphor-icons/react";

/**
 * Site-wide footer. Used on the landing page and (compact variant) inside
 * the authenticated layout. The disclaimer is included as a separate
 * component so it can be embedded standalone in signup/maintenance/AD pages.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-zinc-900 bg-[#0A0A0A]" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 border border-amber flex items-center justify-center">
                <AirplaneTilt size={16} weight="bold" className="text-amber" />
              </div>
              <div className="leading-tight">
                <div className="text-sm font-semibold tracking-tight">OwnerCAM</div>
              </div>
            </div>
            <p className="text-xs text-zinc-500 leading-relaxed">
              Aircraft maintenance tracking and ownership management for general
              aviation owner-operators.
            </p>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono mb-3">Product</div>
            <ul className="space-y-1.5 text-sm text-zinc-400">
              <li><a href="/#features" className="hover:text-zinc-100">Features</a></li>
              <li><a href="/#pricing" className="hover:text-zinc-100">Pricing</a></li>
              <li><a href="/#cost-sharing" className="hover:text-zinc-100">Cost sharing</a></li>
              <li><a href="/#ad-compliance" className="hover:text-zinc-100">AD compliance</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono mb-3">Get started</div>
            <ul className="space-y-1.5 text-sm text-zinc-400">
              <li><Link to="/signup" className="hover:text-zinc-100">Start free trial</Link></li>
              <li><Link to="/login" className="hover:text-zinc-100">Sign in</Link></li>
              <li><a href="/#faq" className="hover:text-zinc-100">FAQ</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono mb-3">Legal</div>
            <ul className="space-y-1.5 text-sm text-zinc-400">
              <li><a href="/#disclaimer" className="hover:text-zinc-100">Disclaimer</a></li>
              <li><span className="text-zinc-600">Terms (coming soon)</span></li>
              <li><span className="text-zinc-600">Privacy (coming soon)</span></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-900 flex flex-col sm:flex-row justify-between items-start gap-4">
          <div className="text-xs text-zinc-500 font-mono uppercase tracking-wider">
            © {year} OwnerCAM · All rights reserved
          </div>
          <div className="text-[10px] text-zinc-600 max-w-md leading-relaxed">
            OwnerCAM is a maintenance tracking tool for private owner-operators of
            non-commercial, non-complex aircraft. It does not replace a licensed
            mechanic, an A&amp;P/IA, a Part-145 organization, a contracted CAMO
            (where one is required for your operation), or the aircraft owner's
            regulatory responsibility.
          </div>
        </div>
      </div>
    </footer>
  );
}
